import { useContext } from "react";
import { KeycloakContext } from "../helpers/KeycloakContext";
export function useKeycloak() {
    const ctx = useContext(KeycloakContext);
    if (!ctx) {
        throw new Error("useKeycloak hook must be used inside KeycloakContext");
    }
    return {
        keycloak: ctx
    };
}
